export const getKistStatus = (kisten, flights) => {
  // create a club_kist status report

  // Create kist lookup map for O(1) access and initialize with all kisten
  const kistStatusMap = new Map()
  kisten.forEach(kist => {
    kistStatusMap.set(kist.id, { 
      ...kist, 
      active_flights: [], 
      has_completed_flights: false 
    })
  })

  // Single pass through flights - O(n)
  flights.forEach(flight => {
    if (flight.kist_id && !flight.is_deleted && !flight.start_methode.endsWith('-a')) {
      const kistData = kistStatusMap.get(flight.kist_id)
      
      if (kistData) {
        // Determine flight status
        let status = ''
        if (flight.start_tijd && !flight.landings_tijd) {
          status = 'in_air'
        } else if (!flight.start_tijd && !flight.landings_tijd) {
          status = flight.gezagvoerder_id ? 'assigned' : 'in_grid'
        } else if (flight.start_tijd && flight.landings_tijd) {
          status = 'available'
          kistData.has_completed_flights = true
        }

        // Add to active flights with organic sorting
        if (status && status !== 'available') {
          const flightData = {
            status,
            flight_uuid: flight.uuid,
            flight
          }
          
          if (status === 'in_air') {
            // Departed flights go to front (highest priority)
            kistData.active_flights.unshift(flightData)
          } else {
            // Not departed (assigned/in_grid) go to back (lower priority)
            kistData.active_flights.push(flightData)
          }
        }
      }
    }
  })

  // return kistStatusMap as an array with status
  const kistStatusArray = []
  for (const kistData of kistStatusMap.values()) {
   kistStatusArray.push(
    {
      ...kistData,
      status: kistData.active_flights.length > 0
        ? kistData.active_flights[0].status
        : kistData.has_completed_flights ? 'available' : 'hangaar',
    }
   ) 
  }
  return kistStatusArray
}

export const getFlightOrder = (flight) => {
  // order is taken first a volg_nummer, if not found start time, if
  if (!flight) return -1
  // sort on volg_nummer, largest above
  if (flight.volg_nummer && flight.landings_tijd) return flight.volg_nummer

  // if start time found, replace non-digits and return the integer value

  if (flight.start_tijd) {
    return (flight.start_tijd_int || parseInt(flight.start_tijd.replace(/\D/g, ''))) * 100
  }

  // if not started, sort on index, newest is concatenated below, as such sorted inverse
  return 1000000 + (flight.registratie ? 0 : 1000) + (flight.index || 0)
}

export const normalizeFlights = (flights) => {
  // normalizes event data for frontend
  const output = []
  flights.forEach((flight) => {
    flight.start_tijd_int = flight.start_tijd ? parseInt(flight.start_tijd.replace(/\D/g, '')) : 9999
    flight.order = getFlightOrder(flight)
    flight.date_time = flight.start_tijd ? Date.parse(flight.datum + 'T' + flight.start_tijd) : new Date(flight.datum)
    output.push(flight)
  })
  return output
}
